export default {
  title: "Общие условия участия",
  orderParticipate: "Порядок участия",
  orderExhib: "Порядок участия в выставке",
  applicationTitle: "Заявка на участие",
  applicationDescription:
    " Для оформления участия в выставке экспоненту необходимо направить в АО\n" +
    "          «ЭКСПОЦЕНТР» заявку. Прием заявок начинается за один год и\n" +
    "          завершается, как правило, за три-четыре месяца до начала выставки.",
  commercialTitle: "Согласование Коммерческого предложения",
  commercialDescription:
    " Стоимость аренды площади разработана с учетом статуса каждой выставки,\n" +
    "          конфигурации и расположения стендов в павильонах. Коммерческое\n" +
    "          предложение можно получить после заполнения заявки на участие.",
  commertialDescr: {
    include1: "В пакет участника выставки входят:",
    include2: "погрузка/разгрузка экспонатов, монтаж/демонтаж оборудования;",
    include3:
      "электроосвещение стенда в пределах 100 Вт установленной мощности\n" +
      "            напряжением 220 В на 1 кв.м. арендованной площади;",
    include4:
      " ежедневная уборка стенда – производится один раз в день и\n" +
      "            предполагает чистку коврового покрытия пола пылесосом, очистку\n" +
      "            корзин для бумаг (уборка производится только при наличии доступа к\n" +
      "            стенду и в определенное время);",
    include5:
      "пропуска для монтажников и проезда автотранспорта на период монтажа\n" +
      "            / демонтажа (только для проведения погрузочно-разгрузочных работ);",
    include6: " удостоверения участника выставки;",
    include7:
      "Выдаются бесплатно из расчета: при площади стенда до 90 кв. м\n" +
      "                  включительно – одно удостоверение на 3 кв. м площади; при\n" +
      "                  площади стенда свыше 90 кв. м – 30 удостоверений плюс по\n" +
      "                  одному Удостоверению на каждые 6 кв. м площади, превышающей 90\n" +
      "                  кв. м. «Удостоверения участника выставки» дают право\n" +
      "                  многократного прохода на территорию AO «ЭКСПОЦЕНТР» как в\n" +
      "                  период работы выставки, так и в период монтажа/демонтажа.",
    include8: "бесплатные приглашения для гостей экспонентов;",
    include9: "Выдаются в Дирекции (строго при 100% оплате аренды).",
    include10:
      " публикация информации об экспоненте в Официальном каталоге выставки\n" +
      "            в объеме, предусмотренном п. 12.4 настоящих Общих условий участия, а\n" +
      "            также предоставление одного экземпляра Официального каталога\n" +
      "            выставки;",
    include11:
      "использование онлайн-системы назначения деловых встреч\n" +
      "            (MatсhMaking);",
    include12:
      " возможность рассылки электронных билетов на выставку для клиентов и\n" +
      "            партнеров (сервис E-Invite);",
    include13:
      "маркетинговые возможности (размещение новостей и новинок на сайте\n" +
      "            выставки, услуги пресс-центра);",
    include14: "  участие в семинаре «Эффективное участие в выставках»",
    include15:
      " Для экспонентов собственных выставок посещение семинара входит\n" +
      "                  в стоимость участия в выставке!",
    include16:
      "Для организаций, не являющихся экспонентами собственных\n" +
      "                  выставок «ЭКСПОЦЕНТРа» участие в семинаре оплачивается на\n" +
      "                  основании выписанного АО «ЭКСПОЦЕНТР» счета.",
    include17:
      " В зависимости от количества участников предоставляются особые\n" +
      "                  условия."
  },
  signContract: {
    title: " Подписание договора",
    info1:
      "После согласования всех условий участия между АО «ЭКСПОЦЕНТР» и\n" +
      "          экспонентом заключается договор (контракт) на участие в выставке, как\n" +
      "          правило, не позднее, чем за 90 дней до начала монтажа. Неотъемлемой\n" +
      "          частью договора являются Общие условия участия со всеми приложениями,\n" +
      "          а также изменениями и дополнениями.",
    info2: "На выставках допускается организация коллективных экспозиций.",
    info3:
      "Для оперативного решения вопросов подготовки и проведения выставки\n" +
      "          между АО «ЭКСПОЦЕНТР» и экспонентом допускаются заключение договора и\n" +
      "          передача других документов путем обмена факсимильными сообщениями и\n" +
      "          электронной почтой с обязательным последующим направлением подлинников\n" +
      "          указанных документов."
  },
  payment: {
    title: "Оплата",
    info1:
      "Экспонент оплачивает регистрационный сбор в размере, установленном АО\n" +
      "          «ЭКСПОЦЕНТР» для конкретной выставки. Сбор взимается на общие\n" +
      "          рекламные и информационные расходы. При отказе от участия в выставке\n" +
      "          регистрационный сбор возврату не подлежит.",
    info2:
      "Компании, полностью не погасившие задолженность за площадь,\n" +
      "          оборудование или дополнительно заказанные услуги, не допускаются на\n" +
      "          монтаж экспозиции.",
    info3:
      " Оплату счетов наличными в рублях возможно произвести в помещении\n" +
      "          Сервис Бюро AO «ЭКСПОЦЕНТР». Максимальная сумма для расчетов наличными\n" +
      "          составляет 100 000 руб"
  },
  closingDocs: {
    title: " Закрывающие документы",
    info1:
      " Закрывающие документы по выставке выдаются в последний день работы\n" +
      "          выставки в Дирекции. В течение первых двух недель документы хранятся у\n" +
      "          менеджеров Дирекции, после чего передаются в Экономический отдел. По\n" +
      "          каждой выставке работает определенный экономист (см. «Руководство\n" +
      "          Участника выставки» на сайте выставки).",
    info2:
      " Для получения закрывающих документов по выставке (счет-фактура, акт\n" +
      "          сдачи-приемки оказанных услуг и выставочных площадей, договор)\n" +
      "          представителю фирмы необходимо в период монтажа подписать акт\n" +
      "          сдачи-приемки оказанных услуг и выставочных площадей в Дирекции\n" +
      "          выставки. При себе необходимо иметь доверенность",
    info3:
      " на право подписи акта, два оригинала договора и инженерную схему в 2-х\n" +
      "          экземплярах (если по каким-либо причинам они не были предоставлены\n" +
      "          ранее).",
    info4:
      " В случае если доверенность\n" +
      "          не оформляется, то представителям компании передаются акты для\n" +
      "          подписания руководством, и после их получения Дирекцией выставки\n" +
      "          выдаются закрывающие финансовые документы по выставке."
  },
  mainDocuments: {
    title: "Основные документы",
    doc1:
      "Общие условия участия в выставках на Центральном выставочном\n" +
      "            комплексе «ЭКСПОЦЕНТР»",
    doc2:
      "Общие условия проведения сопутствующих выставкам и вневыставочных\n" +
      "            мероприятий на Центральном выставочном комплексе «ЭКСПОЦЕНТР»"
  },
  standBuilding: {
    title: "Строительство стендов",
    doc:
      " Правила организации работ застройщиков выставочных стендов и\n" +
      "              экспозиций на территории Центрального выставочного комплекса\n" +
      "              «ЭКСПОЦЕНТР»"
  },
  leavingOrder: {
    title: "Порядок ввоза и вывоза оборудования и экспонатов",
    doc1: " Порядок ввоза/вывоза оборудования и экспонатов",
    doc2:
      " Правила нахождения транспортных средств на территории AO\n" +
      "              «ЭКСПОЦЕНТР»"
  },
  attorney: {
    title: "Доверенности",
    doc1: "D.01 – Доверенность",
    doc2:
      "Форма доверенности от Устроителей выставок, коллективных\n" +
      "              организаторов экспозиций и участников выставок"
  },
  onlineService: {
    title: "Онлайн-сервисы для участников",
    doc1: " Порядок пользования системой назначения деловых встреч MatchMaking",
    doc2:
      "Порядок пользования системой отправки приглашений на выставку\n" +
      "              E-Invite"
  },
  attentionNote: {
    title: "Внимание",
    info1:
      "Все представленные на сайте сведения носят исключительно\n" +
      "            информационный характер, и ни при каких условиях не являются\n" +
      "            публичной офертой, определяемой положениями статьи 437 Гражданского\n" +
      "            кодекса Российской Федерации.",
    info2:
      "Участие в выставках и во вневыставочных мероприятиях (съезды,\n" +
      "            конгрессы, международные и национальные форумы, конференции, деловые\n" +
      "            программы, корпоративные и концертно-развлекательные мероприятия)\n" +
      "            оформляется на основе договора, условия которого согласовываются\n" +
      "            сторонами в каждом конкретном случае. Порядок заключения договоров\n" +
      "            регулируется действующим законодательством Российской Федерации и\n" +
      "            «Общими условиями участия в выставках на Центральном выставочном\n" +
      "            комплексе «ЭКСПОЦЕНТР», «Общими условиями проведения сопутствующих\n" +
      "            выставкам и вневыставочных мероприятий на Центральном выставочном\n" +
      "            комплексе «ЭКСПОЦЕНТР»."
  },
  note: "Примечение"
};
